import React from "react";

export default function Header() {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="flex h-16 items-center justify-center px-4">
        <img
          src="/binntu_logo.png"
          alt="Binntu Driver"
          className="h-8 w-auto object-contain"
        />
      </div>
    </header>
  );
}
